export default "__VITE_ASSET__515b3cd3__"